import * as React from 'react';
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { MainContent, SideMenu, TopMenu } from './';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}));

export default function Layout({ sideMenu, contentTop, contentBottom }) {
  const classes = useStyles();

  const [isDark, setIsDark] = React.useState(true);
  const toggleDark = () => setIsDark(!isDark);

  const theme = createMuiTheme({
    palette: {
      type: isDark ? 'dark' : 'light',
      primary: {
        main: '#269eff',
      },
    },
    toggleDark,
  });

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />
        <TopMenu />
        <SideMenu>{sideMenu}</SideMenu>
        <MainContent>
          {contentTop}
          {contentBottom}
        </MainContent>
      </div>
    </ThemeProvider>
  );
}
